module.exports = __webpack_public_path__ + "img/arrow-hover.9c0b1e15.svg";